
export default {

    setCount(state, count) {
      state.count = count
    },

    setCurrentArchive (state, archive) {
      state.current = archive
    },

    setArchives (state, archives) {
      state.all = archives
      state.initialized = true
      state.page = 1
    },

    setNextArchives (state, archives) {    
      state.all = [ ...state.all, ...archives ]
      state.page++
    }
}